<template>
  <div class="row">
    <div class="col-12">
      <div class="d-flex align-items-center justify-content-between mb-4">
        <h4><i class="fas fa-history"></i> Condições Financeiras</h4>
        <div>
          <button
            class="btn active btn-outline-secondary btn-sm"
            title="Voltar para Identificação da Família e Endereço"
            @click="$emit('voltar')"
          >
            <i class="mdi mdi-arrow-left"></i>Voltar
          </button>
        </div>
      </div>
    </div>
    <loading-animation
      :active.sync="loading"
      :is-full-page="false"
      :opacity="1"
      color="#5895FF"
    />
    <div
      class="col-md-6 mb-3"
      v-for="financeiro in financeiros"
      :key="financeiro.id"
    >
      <div class="card border">
        <div class="card-header bg-gray">
          <p>
            Data <b>{{ financeiro.created_at || formatDate }}</b>
          </p>
          <p>
            Técnico <b>{{ financeiro.user_id }}</b>
          </p>
        </div>
        <div class="card-body">
          <p>
            <b>Renda total da família</b>
            {{ financeiro.renda_total_familiar | moedaRS() }}
          </p>
          <p>
            <b>Valor da renda média (per capita) da família</b>
            {{ parseFloat(financeiro.per_capita_familiar) | moedaRS() }}
          </p>
          <p>
            <b>Renda total da família (incluindo programas sociais)</b>
            {{
              (financeiro.renda_total_familiar + programas + beneficios)
                | moedaRS()
            }}
          </p>
          <p>
            <b>Energia elétrica</b>
            {{ financeiro.val_desp_energia | moedaRS() }}
          </p>
          <p><b>Água e esgoto</b> {{ financeiro.val_desp_agua }}</p>
          <p>
            <b>Gás, carvão e lenha</b>
            {{ financeiro.val_desp_gas | moedaRS() }}
          </p>
          <p>
            <b>Alimentação, higiene e limpeza</b>
            {{ financeiro.val_desp_alimentacao | moedaRS() }}
          </p>
          <p>
            <b>Transporte</b> {{ financeiro.val_desp_transporte | moedaRS() }}
          </p>
          <p><b>Aluguel</b> {{ financeiro.val_desp_aluguel | moedaRS() }}</p>
          <p>
            <b>Medicamentos de uso regular</b>
            {{ financeiro.val_desp_medicamentos | moedaRS() }}
          </p>
          <p>
            <b>Outras despesas</b> {{ financeiro.val_desp_outros | moedaRS() }}
          </p>
          <p>
            <b>Total de despesas</b> {{ financeiro.total_desp | moedaRS() }}
          </p>
          <p>
            <b>Observação</b>
            {{ financeiro.observacoes_financeiro | moedaRS() }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Read",
  props: ["familiaId"],
  data() {
    return {
      loading: true,
      financeiros: {},
      programas: 0,
      beneficios: 0,
      renda_percapita: 0,
    };
  },
  mounted() {
    this.getfinanceiro();
  },
  methods: {
    getfinanceiro() {
      axios
        .get("api/dashboard/familias/historico/financeiro/" + this.familiaId)
        .then((response) => {
          this.financeiros = response.data.data;
          this.programas = response.data.programas;
          this.beneficios = response.data.beneficios;
          this.loading = false;
        })
        .catch(() => {
          this.$router.push(
            "/dashboard/familias/edit/" + this.familiaId + "/identificacao"
          );
        });
    },
    dateConverter(date) {
      if (date) {
        return moment(date).format("DD/MM/YYYY");
      } else {
        return "";
      }
    },
    pergunta(item) {
      var value = item == 1 ? 0 : 1;
      return this.$root.arrays.pergunta[value].value;
    },
    verificarResposta(resposta, array) {
      const result = array.filter((item) => item.id == resposta);
      return result[0] ? result[0].value : "";
    },
  },
};
</script>
